import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalService } from './global/global.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserStoreService } from './user/user-store.service';
import { UserRequestsService } from './user/user-requests.service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { ModalIconComponent } from '../theme/components/modal-icon/modal-icon.component';
import { MatDialog } from '@angular/material/dialog';
import { RescueStoreService } from './rescue/rescue-store.service';
import { RescueRequestsService } from './rescue/rescue-requests.service';
import { DialogService } from './dialog/dialog.service';
import { PERMISSIONUSER } from './constant-services.data';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  requests = 0;
  flagVerOperacion: string;
  store: string; 
  constructor(
    private userStore: UserStoreService,
    private router: Router,
    public rescueRequestsService: RescueRequestsService,
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      this.store = (this.userStore && this.userStore.activeCUC && this.userStore.activeCUC.cuc)?this.userStore.activeCUC.cuc:'';
      this.flagVerOperacion = (this.userStore && this.userStore.activeCUC && this.userStore.activeCUC.flagVerOperacion)?this.userStore.activeCUC.flagVerOperacion:'';
      var res = false; 

      if(this.store === ''){
        this.router.navigate(['/login'])
        return false;
      }

      if(this.flagVerOperacion !== 'S'){
        var path = route.url[0].path;
        var permissionUser = PERMISSIONUSER;
        permissionUser.forEach(item => {
          if(res == false){
            res = path.includes(item);
          }
        })
      }else{
        return true;
      }

      if (!res) { 
        return true;
      }else
      {
        this.router.navigate(['/perfil/dashboard'])
        return false;
        
      }
   
    } 

}
